
    import { Component, Vue, Prop } from 'vue-facing-decorator';
    import { removeMdiBracketToIcon } from '@/mdi';
    @Component({
        components: {
        },
    })
    export default class MapLegend extends Vue {
        @Prop({ default: null }) public data: any;

        private convertTitle(input: string) {
            return removeMdiBracketToIcon(input);
        }
    }
